<div
  class="w-full flex flex-col h-96 divide-y divide-gray-100 dark:divide-white/10 overflow-hidden shadow-card-container-pale">
  <div class="shrink-0 p-2 flex flex-row flex-wrap items-center justify-between gap-2">
    <div class="flex min-w-0 items-center flex-1">
      <div class="shrink-0">
        <div
          class="size-10 rounded-xl bg-primary/20 text-accent text-sm font-semibold flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-6" aria-hidden="true">
            <path d="M13 5h8" />
            <path d="M13 12h8" />
            <path d="M13 19h8" />
            <path d="m3 17 2 2 4-4" />
            <rect x="3" y="4" width="6" height="6" rx="1" />
          </svg>
        </div>
      </div>
      <div class="ml-4 min-w-0">
        <h3 class="text-md font-semibold text-primary">Latest Briefs</h3>
        <p class="hidden text-sm text-secondary sm:block">
          Briefs you've created most recently.
        </p>
      </div>
    </div>

    <button type="button" routerLink="/briefs"
      class="shrink-0 secondary-button text-secondary inline-flex flex-row items-center gap-x-2">View
      All
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="size-5 text-secondary" aria-hidden="true">
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
      </svg>
    </button>
  </div>
  <div class="flex-1 flex flex-col px-2 py-2 overflow-hidden max-h-full">
    @if (loadingState() === 'loading') {
      <div class="w-full overflow-hidden">
        <ul class="flex flex-col divide-y divide-gray-100 dark:divide-white/10" aria-hidden="true">
          @for (row of skeletonRows; track row) {
          <li class="relative overflow-hidden flex flex-row items-center gap-x-3 px-2 py-2.5">
              <div class="min-w-0 flex-1 space-y-2">
                  <div class="h-3 w-1/2 rounded-full bg-gray-200 dark:bg-white/10"></div>
                  <div class="h-2 w-3/4 rounded-full bg-gray-200 dark:bg-white/10"></div>
              </div>
              <div class="shrink-0 size-5 rounded-full bg-gray-200 dark:bg-white/10"></div>
              <div class="skeleton-shimmer"></div>
          </li>
          }
      </ul>
    </div>
    } @else if (loadingState() === 'error') {
    <p class="text-sm text-red-600 dark:text-red-400" role="alert">Unable to load latest briefs. Please try again
      later.</p>
    } @else if (latestBriefs().length === 0) {
    <div class="w-full flex flex-col items-center justify-center p-4 h-full">
      <div class="text-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="mx-auto size-12 text-gray-400 dark:text-gray-500">
          <path
            d="M11.35 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5.35" />
          <path d="M14 2v5a1 1 0 0 0 1 1h5" />
          <path d="M14 19h6" />
          <path d="M17 16v6" />
        </svg>
        <h3 class="mt-2 text-sm font-semibold text-primary">No briefs yet</h3>
        <p class="mt-1 text-sm text-secondary">Create a brief to see it here.</p>
        <div class="mt-6 w-full flex flex-row items-center justify-center">
          <button [routerLink]="['/create-brief-select']" type="button"
              class="mx-auto inline-flex items-center gap-x-1.5 flashy-go-button">
              Create Brief
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" class="size-5">
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
              </svg>
          </button>
      </div>
      </div>
    </div>
    } @else {
    <ul class="lg:hidden flex flex-col divide-y divide-gray-100 dark:divide-white/10 overflow-y-auto h-full scrollbar-transparent animated fadeIn">
      @for (brief of latestBriefs(); track $index) {
      <li>
        <button type="button" (click)="navigateToBrief(brief.id)"
          class="w-full min-w-0 text-left px-2 py-3 flex flex-col gap-2 rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/50">
          <div class="flex min-w-0 items-start justify-between gap-2">
            <div class="min-w-0 flex-1">
              <h3 class="m-0 text-sm font-semibold leading-5 text-primary line-clamp-2">{{ brief.title }}</h3>
              <p class="m-0 mt-1 text-xs text-secondary truncate">{{ brief.campaign }}</p>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="size-5 shrink-0 text-indigo-600" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
            </svg>
          </div>
          <dl class="m-0 grid grid-cols-5 gap-1 text-center">
            <div>
              <dt class="text-xs text-secondary">Invited</dt>
              <dd class="m-0 text-sm font-semibold text-indigo-600">{{ brief.invited }}</dd>
            </div>
            <div>
              <dt class="text-xs text-secondary">Applied</dt>
              <dd class="m-0 text-sm font-semibold text-indigo-600">{{ brief.applied }}</dd>
            </div>
            <div>
              <dt class="text-xs text-secondary">Hired</dt>
              <dd class="m-0 text-sm font-semibold text-indigo-600">{{ brief.hired }}</dd>
            </div>
            <div>
              <dt class="text-xs text-secondary">Started</dt>
              <dd class="m-0 text-sm font-semibold text-indigo-600">{{ brief.started }}</dd>
            </div>
            <div>
              <dt class="text-xs text-secondary">Done</dt>
              <dd class="m-0 text-sm font-semibold text-indigo-600">{{ brief.complete + brief.started }}</dd>
            </div>
          </dl>
        </button>
      </li>
      }
    </ul>
    <div class="hidden lg:block w-full overflow-x-auto overflow-y-auto h-full scrollbar-transparent animated fadeIn">
      <div class="inline-block min-w-full align-middle">
        <table class="min-w-full divide-y divide-gray-300 dark:divide-white/10">
          <thead>
            <tr>
              <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-primary sm:pl-0">Name</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-primary">Invited</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-primary">Applied</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-primary">Hired</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-primary">Started</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-primary">Complete</th>
              <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-0">
                <span class="sr-only">Edit</span>
              </th>
            </tr>
          </thead>

          <tbody class="divide-y divide-gray-200 dark:divide-white/10">
            @for (brief of latestBriefs(); track $index) {
            <tr (click)="navigateToBrief(brief.id)" class="hover:bg-blue-50 dark:hover:bg-blue-900/50 cursor-pointer">
              <!-- Title -->
              <td class="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-primary sm:pl-0">
                <div class>
                  <h3 class="text-sm font-semibold leading-6 text-primary">{{
                    brief.title }}</h3>
                  <div class="flex flex-row items-center gap-x-4">
                    <p class="text-sm font-normal text-secondary">{{ brief.campaign

                      }}</p>

                  </div>
                </div>
              </td>
              <!-- Title END -->

              <!-- Invited -->
              <td class="whitespace-nowrap px-3 py-2 text-sm text-secondary">
                <dd class="mt-1 flex items-baseline justify-between md:block lg:flex">
                  <div class="flex items-baseline text-sm font-semibold text-indigo-600">
                    {{ brief.invited }}
                  </div>

                  @if (brief.appliedNew > 0) {
                  <div
                    class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-sm font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                    {{ brief.appliedNew }} new
                  </div>
                  }
                </dd>
              </td>
              <!-- Invited END -->

              <!-- Applied -->
              <td class="whitespace-nowrap px-3 py-2 text-sm text-secondary">
                <dd class="mt-1 flex items-baseline justify-between md:block lg:flex">
                  <div class="flex items-baseline text-sm font-semibold text-indigo-600">
                    {{ brief.applied }}
                  </div>

                  @if (brief.invitedNew > 0) {
                  <div
                    class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-sm font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                    {{ brief.invitedNew }} new
                  </div>
                  }
                </dd>
              </td>
              <!-- Applied END -->

              <!-- Hired -->
              <td class="whitespace-nowrap px-3 py-2 text-sm text-secondary">
                <dd class="mt-1 flex items-baseline justify-between md:block lg:flex">
                  <div class="flex items-baseline text-sm font-semibold text-indigo-600">
                    {{ brief.hired }}
                  </div>
                  @if (brief.hiredNew > 0) {
                  <div
                    class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-sm font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                    {{ brief.hiredNew }} new
                  </div>
                  }
                </dd>
              </td>
              <!-- Hired END -->

              <!-- Started -->
              <td class="whitespace-nowrap px-3 py-2 text-sm text-secondary">
                <dd class="mt-1 flex items-baseline justify-between md:block lg:flex">
                  <div class="flex items-baseline text-sm font-semibold text-indigo-600">
                    {{ brief.started }}
                  </div>
                  @if (brief.startedNew > 0) {
                  <div
                    class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-sm font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                    {{ brief.startedNew }} new
                  </div>
                  }
                </dd>
              </td>
              <!-- Started END -->

              <!-- Complete -->
              <td class="whitespace-nowrap px-3 py-2 text-sm text-secondary">
                <dd class="mt-1 flex items-baseline justify-between md:block lg:flex">
                  <div class="flex items-baseline text-sm font-semibold text-indigo-600">
                    {{ brief.complete + brief.started }}
                  </div>

                  @if (brief.completeNew > 0) {
                  <div
                    class="inline-flex items-baseline rounded-full px-2.5 py-0.5 text-sm font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0">
                    {{ brief.completeNew }} new
                  </div>
                  }
                </dd>
              </td>
              <!-- Complete END -->

              <!-- Action -->
              <td class="relative whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                <a class="text-indigo-600 hover:text-indigo-900">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                  </svg>
                </a>
              </td>
              <!-- Action -->
            </tr>
            }

            <!-- More people... -->
          </tbody>
        </table>
      </div>
    </div>
    }
  </div>
</div>